if (!customElements.get("wim-cart-subscription-selector")) {
  customElements.define(
    "wim-cart-subscription-selector",
    class WimCartSubscriptionSelector extends HTMLElement {
      connectedCallback() {
        this.addEventListener("change", this.onChange.bind(this));
      }

      get cartItems() {
        return this.closest("cart-items");
      }

      onChange(event) {
        event.preventDefault();
        event.stopPropagation();

        const input = event.target;
        const isSubscribed =
          input.type === "checkbox"
            ? input.checked
            : input.value === "subscription";
        const line = parseInt(this.getAttribute("data-line"), 10);
        const quantity = parseInt(this.getAttribute("data-quantity"), 10);
        const lineKey = this.getAttribute("data-line-key");
        const sellingPlanId = isSubscribed
          ? this.getAttribute("data-selling-plan-id")
          : "";

        if (this.cartItems) {
          this.cartItems.enableLoading(lineKey);
        }

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:bundled-sections", {
            bubbles: true,
            detail: { sections: sectionsToBundle },
          }),
        );

        const body = JSON.stringify({
          line,
          quantity,
          selling_plan: sellingPlanId || null,
          sections: sectionsToBundle,
        });

        fetch(theme.routes.cart_change_url, {
          ...theme.utils.fetchConfig(),
          body,
        })
          .then((response) => response.json())
          .then((parsedState) => {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              source: "wim-cart-subscription",
              cart: parsedState,
            });
          })
          .catch((error) => {
            console.error(error);
            if (this.cartItems) {
              this.cartItems.disableLoading(lineKey);
            }
          });
      }
    },
  );
}
